import { render, staticRenderFns } from "./EditBooking.vue?vue&type=template&id=28bf85bd&lang=html&"
import script from "./EditBooking.vue?vue&type=script&lang=js&"
export * from "./EditBooking.vue?vue&type=script&lang=js&"
import style0 from "./EditBooking.vue?vue&type=style&index=0&id=28bf85bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports